import { createAction } from "typesafe-actions";
import { RoutesState } from "./types";

export const hideRoutes = createAction("HEADER/HIDE_ROUTES")<{
  lastShownRouteWidth: number;
}>();

export const showRoutes = createAction("HEADER/SHOW_ROUTES")<{
  count: number;
}>();

export const switchToOffline = createAction("HEADER/SWITCH_TO_OFFLINE")<{
  newRoutesState: RoutesState;
}>();
